module.exports = __webpack_public_path__ + "static/media/Dianne Gault.38d5a601.png";